export default "__VITE_ASSET__BUbNBOro__"